var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Output } from '@angular/core';
import { FileComponent } from '../../../../items/columns/file/file.component';
import { ColumnService } from '../../../../items/columns/column/column.service';
import { ConfigService } from '../../../../service/config.service';
import { ApiService } from '../../../../service/api.service';
import { FileService } from '../../../../items/columns/file/file.service';
import { ColumnBaseService } from '../../../../items/columns/base/columnbase.service';
import { FileUpload } from './report.service';
import { LoadingService } from '../../../../component/loading/loading.service';
var KtsReportFileUploadComponent = /** @class */ (function (_super) {
    __extends(KtsReportFileUploadComponent, _super);
    function KtsReportFileUploadComponent(service, baseService, fileService, config, api, loadingService) {
        var _this = _super.call(this, service, baseService, fileService, config, api, loadingService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.fileService = fileService;
        _this.config = config;
        _this.api = api;
        _this.loadingService = loadingService;
        _this.changeMsg = new EventEmitter();
        _this.msgs = [];
        return _this;
    }
    KtsReportFileUploadComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        Dropzone.forElement(this.element).destroy();
        var acceptedFiles = jsonpath.value(this.col, '$.params.options.acceptedFiles') || 'image/*';
        acceptedFiles = (acceptedFiles === '*' ? null : acceptedFiles);
        var maxFilesize = jsonpath.value(this.col, '$.params.options.maxFilesize');
        this.element = this.fileElement.nativeElement;
        var self = this;
        $(this.element).dropzone({
            url: this.host + "/upload",
            headers: this.api.getCsrfToken(),
            paramName: 'file',
            acceptedFiles: acceptedFiles,
            maxFilesize: maxFilesize ? maxFilesize : 1,
            addRemoveLinks: true,
            withCredentials: true,
            dictInvalidFileType: self.msg['au.COMPONENT.FileComponent.label.invalidFileType'],
            dictRemoveFile: self.msg['au.COMPONENT.FileComponent.label.removeFile'],
            params: {
                uploadType: jsonpath.value(self.col, '$.params.uploadType') || null
            },
            init: function () {
                this.on('addedfile', function (file) {
                    self.loadingService.on();
                });
                this.on('complete', function (file) {
                    self.loadingService.off();
                });
            },
            success: function (file, responseText, e) {
                if (responseText.url) {
                    if (responseText.url && responseText.url.match(/(.+\/)(.+?)$/)) {
                        self.path = RegExp.$1;
                        self.uploadFileName = RegExp.$2;
                    }
                    self.fileName = self.uploadFileKey ? file.name : self.uploadFileName;
                }
                self.onChange();
                this.removeFile(file);
            },
            error: function (file, message) {
                if (file.xhr && file.xhr.status === 401) {
                    self.api.onUnauthorized(message);
                }
                if (typeof message !== 'string' && message.message) {
                    message = message.message;
                }
                self.msgs.push({ message: message + ' (' + file.name + ')', error: true });
                self.onChangeMsg();
            }
        });
    };
    KtsReportFileUploadComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
    };
    KtsReportFileUploadComponent.prototype.onEvent = function (e) {
        this.msgs = [];
        this.onChangeMsg();
        $(this.element).trigger('click');
    };
    KtsReportFileUploadComponent.prototype.onChange = function () {
        _super.prototype.onChange.call(this);
        var file = this.fileService.getFile(this.componentName, this.baseService.getColKey(this.componentName, this.col.key, this.index));
        var val = new FileUpload();
        val.file = file.url;
        if (this.nameTypeKey) {
            val.name_type = file.type;
        }
        if (this.uploadFileKey) {
            val.upload_file = file.uploadFileName;
        }
        if (this.fileName) {
            val.file_name = file.fileName;
        }
        this.changeVal.emit({ key: this.col.key, val: val });
        if (this.msgs.length === 0 || (this.msgs.length > 0 && this.msgs[0].error)) {
            this.msgs.unshift({ message: this.msg['au.COMPONENT.KtsReportComponent.label.add_photo'] });
        }
        this.onChangeMsg();
    };
    KtsReportFileUploadComponent.prototype.onChangeMsg = function () {
        this.changeMsg.emit(this.msgs);
    };
    KtsReportFileUploadComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    KtsReportFileUploadComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-report-file-upload',
                    template: "\n        <item-btn [key]=\"'btn'\" [btn]=\"{\n          type: 'button',\n          event: colKey,\n          caption: msg['au.COMPONENT.KtsReportComponent.button.upload']\n        }\" (clickBtn)=\"onEvent($event)\"></item-btn>\n        <div class=\"dropzone\" style=\"display: none;\" #file></div>\n    "
                }] }
    ];
    /** @nocollapse */
    KtsReportFileUploadComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: FileService },
        { type: ConfigService },
        { type: ApiService },
        { type: LoadingService }
    ]; };
    KtsReportFileUploadComponent.propDecorators = {
        changeMsg: [{ type: Output }]
    };
    return KtsReportFileUploadComponent;
}(FileComponent));
export { KtsReportFileUploadComponent };
//# sourceMappingURL=report-file-upload.component.js.map